function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5397 10.8477C14.9033 11.378 14.8173 12.3239 15.3477 12.9603C15.878 13.5967 16.8239 13.6827 17.4603 13.1523L21.4603 9.81901C21.7928 9.54194 21.9894 9.13476 21.9996 8.70208C22.0098 8.2694 21.8326 7.8534 21.5136 7.56094L17.5136 3.89428C16.9029 3.33449 15.9541 3.37574 15.3943 3.98642C14.8345 4.5971 14.8757 5.54595 15.4864 6.10574L16.462 7.00001H13C12.1716 7.00001 11.5 7.67158 11.5 8.50001C11.5 9.32844 12.1716 10 13 10H16.5569L15.5397 10.8477Z",
  fill: "#DCD8E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9603 21.8477C13.5967 22.378 13.6827 23.3239 13.1523 23.9603C12.622 24.5967 11.6761 24.6827 11.0397 24.1523L7.03972 20.819C6.70724 20.5419 6.51063 20.1348 6.50042 19.7021C6.4902 19.2694 6.66737 18.8534 6.98641 18.5609L10.9864 14.8943C11.5971 14.3345 12.5459 14.3757 13.1057 14.9864C13.6655 15.5971 13.6243 16.546 13.0136 17.1057L12.038 18H15.5C16.3284 18 17 18.6716 17 19.5C17 20.3284 16.3284 21 15.5 21H11.9431L12.9603 21.8477Z",
  fill: "#DCD8E6"
});

var SvgIntegration = function SvgIntegration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/integration.de305c00.svg";
export { ForwardRef as ReactComponent };